/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '../../../base/reset/css/reset';
import './bootstrap.scss';
